import type { CSSProperties } from 'react';
import type { BookData } from '@/mocks/books';

const SKEW = '30deg';
const FOIL_LAYERS = 5;
const FOIL_OFFSET = 1.4;

interface BookProps {
  book: BookData;
}

export default function Book({ book }: BookProps) {
  const hasVisibleTitle = book.textColor !== 'transparent';
  const hasVideo = Boolean(book.coverVideo);

  const coverStyle: CSSProperties = hasVideo
    ? {
        background: book.cover,
        transform: `skewY(${SKEW})`,
      }
    : book.coverImage
      ? {
          backgroundImage: `url(${book.coverImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: `skewY(${SKEW})`,
        }
      : { background: book.cover, transform: `skewY(${SKEW})` };

  const foilLayers = Array.from({ length: FOIL_LAYERS }, (_, i) => {
    const offset = (i + 1) * FOIL_OFFSET;
    const brightness = 1 - i * 0.07;

    return (
      <div
        key={i}
        className="book-foil-edge"
        style={{
          transform: `translate(${offset}px, ${offset}px) skewY(${SKEW})`,
          zIndex: 999 - i,
          filter: `brightness(${brightness.toFixed(2)})`,
        }}
      />
    );
  });

  return (
    <div className="book">
      {foilLayers}
      <div className="book-layer book-front-cover" style={coverStyle}>
        {hasVideo && (
          <video
            className="book-cover-video"
            src={book.coverVideo}
            poster={book.coverImage}
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          />
        )}
        {hasVisibleTitle && (
          <span className="book-cover-title" style={{ color: book.textColor }}>
            {book.title}
          </span>
        )}
      </div>
    </div>
  );
}